import styled, { keyframes } from 'styled-components'

const shimmer = keyframes`
  100% {
    transform: translateX(100%);
  }
`
const backgroundShimmer = keyframes` 0% { background-position: 100% 0; } 100% { background-position: -100% 0; } `

const BasicCardContainer = styled.div`
  position: relative;
  overflow: hidden;

  background-color: ${({ theme }) => theme.app.skeletonMutedBase};

  background-image: linear-gradient(
    110deg,
   ${({ theme }) => theme.app.skeletonMutedEdge} 8%,
  ${({ theme }) => theme.app.skeletonMutedBase} 24%,
  ${({ theme }) => theme.app.skeletonMutedShine} 38%,
  ${({ theme }) => theme.app.skeletonMutedBase} 52%,
  ${({ theme }) => theme.app.skeletonMutedEdge} 70%
  );

  background-size: 220% 100%;
  background-position: 100% 0;

  border-radius: ${({ radius = '8px' }) => radius};
  width: ${({ width }) => width};
  height: ${({ height }) => height};

  animation: ${backgroundShimmer} 1.7s ease-in-out infinite;
`

const CardContainer = styled.div`
  position: relative;
  overflow: hidden;

  background-color: ${({ theme }) => theme.app.skeletonBase};

  background-image: linear-gradient(
    110deg,
   ${({ theme }) => theme.app.skeletonEdge} 8%,
  ${({ theme }) => theme.app.skeletonBase} 24%,
  ${({ theme }) => theme.app.skeletonShine} 38%,
  ${({ theme }) => theme.app.skeletonBase} 52%,
  ${({ theme }) => theme.app.skeletonEdge} 70%
  );

  background-size: 220% 100%;
  background-position: 100% 0;

  border-radius: ${({ radius = '8px' }) => radius};
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  ${({ $maxWidth }) => $maxWidth && `max-width: ${$maxWidth};`}
  ${({ $minWidth }) => $minWidth && `min-width: ${$minWidth};`}
  ${({ $aspectRatio }) => $aspectRatio && `aspect-ratio: ${$aspectRatio};`}

  animation: ${backgroundShimmer} 1.7s ease-in-out infinite;
`

const Shimmer = styled.div`
  position: relative;
  overflow: hidden;

  background-color: ${({ theme }) => theme.app.skeletonBase};

  background-image: linear-gradient(
    110deg,
   ${({ theme }) => theme.app.skeletonEdge} 8%,
  ${({ theme }) => theme.app.skeletonBase} 24%,
  ${({ theme }) => theme.app.skeletonShine} 38%,
  ${({ theme }) => theme.app.skeletonBase} 52%,
  ${({ theme }) => theme.app.skeletonEdge} 70%
  );
  background-size: 220% 100%;
  background-position: 100% 0;

  border-radius: ${({ radius = '8px' }) => radius};
  width: ${({ width }) => width};
  height: ${({ height }) => height};

  animation: ${backgroundShimmer} 1.7s ease-in-out infinite;
`
const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  padding: 16px;
  justify-content: space-between;
`
const Footer = styled.div``


const HeaderSection = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    padding-top: 20px;
    border-bottom-left-radius: 32px;
    border-bottom-right-radius: 32px;
    position: relative;
`

const HeaderLeft = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    flex: 1;
`

export { CardContainer, Shimmer, Footer, CardWrapper, BasicCardContainer, HeaderSection, HeaderLeft }
